var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_box"},[_c('el-container',[_c('el-aside',{attrs:{"width":"220px"}},[_c('Left')],1),_c('el-container',[_c('el-header',[_c('Top')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }